"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cappella-de-picenardi": {
    "57952b0c": [{
      "hkey": "89696f95",
      "slug": "cappella-de-picenardi",
      "name": "Cappella de' Picenardi",
      "primary": true,
      "skipSearch": false
    }],
    "mottaiola-de-padri": [{
      "hkey": "89696f95",
      "slug": "cappella-de-picenardi",
      "name": "Cappella de' Picenardi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;